import { useTranslation } from "react-i18next";

import type { EmdrSetRecord } from "../../domain/emdrSets";
import { ratingPoints } from "../../domain/emdrSummary";
import SetCurve from "./SetCurve";

/**
 * SUD and VOC across the session's sets, side by side: two charts on their
 * own scales, never one with two axes. Each appears once it has two points
 * to join.
 */
export default function EmdrRatingCharts({ sets }: { sets: EmdrSetRecord[] }) {
    const { t } = useTranslation();
    const sud = ratingPoints(sets, "sud");
    const voc = ratingPoints(sets, "voc");
    if (sud.length < 2 && voc.length < 2) return null;
    const setLabel = (n: number) => t("emdr.console.history.set", { number: n });
    const setNumbers = sets.map((set) => set.set_number);

    return (
        <div className="grid gap-6 sm:grid-cols-2" data-testid="emdr-rating-charts">
            {sud.length >= 2 && (
                <SetCurve
                    points={sud}
                    min={0}
                    max={10}
                    ticks={[0, 5, 10]}
                    title={t("emdr.session.charts.sud")}
                    hint={t("emdr.session.charts.sudHint")}
                    unit="SUD"
                    setNumbers={setNumbers}
                    setLabel={setLabel}
                />
            )}
            {voc.length >= 2 && (
                <SetCurve
                    points={voc}
                    min={1}
                    max={7}
                    ticks={[1, 4, 7]}
                    title={t("emdr.session.charts.voc")}
                    hint={t("emdr.session.charts.vocHint")}
                    unit="VOC"
                    setNumbers={setNumbers}
                    setLabel={setLabel}
                />
            )}
        </div>
    );
}
